import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { useAuth } from "@/context/AuthContext";

export default function AuthCallback() {
  const { exchangeSession, reload } = useAuth();
  const navigate = useNavigate();
  const done = useRef(false);

  useEffect(() => {
    if (done.current) return;
    done.current = true;
    const sessionId = new URLSearchParams(window.location.hash.slice(1)).get("session_id");
    const started = Number(sessionStorage.getItem("lamka_auth_pending"));
    sessionStorage.removeItem("lamka_auth_pending");
    // Only accept sign-ins this browser started in the last 10 minutes
    if (!started || Date.now() - started > 10 * 60 * 1000) {
      setTimeout(() => toast.error("That sign-in link wasn't started here. Please sign in again."), 0);
      reload();
      navigate("/login", { replace: true });
      return;
    }
    exchangeSession(sessionId)
      .then((u) => {
        toast.success(`Signed in as ${u?.name || u?.email || "Lamka member"}`);
        navigate("/", { replace: true });
      })
      .catch(() => {
        toast.error("Sign-in failed. Please try again.");
        reload();
        navigate("/login", { replace: true });
      });
  }, [exchangeSession, reload, navigate]);

  return (
    <div data-testid="auth-callback" className="min-h-screen bg-[#0F0F0F] flex items-center justify-center">
      <p className="font-mono text-xs uppercase tracking-[0.3em] text-[#C5A059] animate-pulse">Signing you in…</p>
    </div>
  );
}
